import React from "react";
import MoveStepNode from "./MoveStepNode";
import RenderHtml from "../../../../../common/AppSpecificConpnents/PartsTable/RenderHtml";

/**
 * MoveSectionNode Component
 * Renders a section for move position selection
 */
const MoveSectionNode = ({
  section,
  sectionIndex,
  globalStepStart,
  checkboxState,
  moveNodeType,
  checkboxLabelColor,
  customOnNavigate,
  shouldDisableStepCheckbox,
  shouldShowStepCheckbox,
  shouldDisableSubstepCheckbox,
  shouldShowSubstepCheckbox,
  shouldDisableChildCheckbox,
  shouldShowChildCheckbox,
  preloadedData,
  compareSiblingOrders,
}) => {
  const sectionHeading = `Section ${sectionIndex + 1}`;

  // Determine checkbox state
  const isCurrent = checkboxState?.currentNodeId === section.tree_node_id && 
                    checkboxState?.currentNodeType === 'section';
  const isSourceSection = checkboxState?.sourceNodeId === section.tree_node_id;
  const isChecked = isCurrent || checkboxState?.allChildrenChecked || isSourceSection;
  const isDisabled = false; // Sections are never disabled

  // Show section checkbox only if moving section or step
  const showSectionCheckbox = moveNodeType === 'section' || moveNodeType === 'step';

  return (
    <div
      key={section.tree_node_id}
      style={{
        margin: "20px 0",
        clear: "both",
      }}
    >
      <div
        style={{
          clear: "both",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        {showSectionCheckbox && (
          <input
            type="checkbox"
            checked={isChecked}
            disabled={isDisabled}
            onChange={() => {
              if (isSourceSection) return;
              if (!isDisabled && customOnNavigate) {
                customOnNavigate("section", section, { 
                  sectionIndex,
                  sectionHeading,
                  sectionId: section.tree_node_id
                });
              }
            }}
            style={{ 
              cursor: isDisabled ? "not-allowed" : "pointer",
              accentColor: isSourceSection ? "black" : undefined,
            }}
          />
        )}
        <h2 
          onClick={() => {
            if (isSourceSection) return;
            if (!isDisabled && showSectionCheckbox && customOnNavigate) {
              customOnNavigate("section", section, { 
                sectionIndex,
                sectionHeading,
                sectionId: section.tree_node_id
              });
            }
          }}
          style={{ 
            fontSize: "20px", 
            margin: 0,
            color: showSectionCheckbox ? (checkboxLabelColor || undefined) : undefined,
            cursor: isSourceSection ? "not-allowed" : ((!isDisabled && showSectionCheckbox) ? "pointer" : "default"),
            userSelect: "none"
          }}
        >{sectionHeading}</h2>
      </div>
      <hr />
      <hr />
      <RenderHtml content={section.detail?.section_name || section.section_name || ""} />
      <RenderHtml content={section.detail?.short_description || section.short_description || ""} />

      {/* Render steps */}
      {section.steps && section.steps.length > 0 && (
        <>
          {[...section.steps].sort((a, b) => {
            const orderA = parseInt(a.sibling_order || a.procedure_tree?.sibling_order || 0, 10);
            const orderB = parseInt(b.sibling_order || b.procedure_tree?.sibling_order || 0, 10);
            return orderA - orderB;
          }).map((step, stepIndex) => {
            const globalStepNumber = globalStepStart + stepIndex + 1;
            return (
              <MoveStepNode
                key={step.tree_node_id}
                step={step}
                stepIndex={stepIndex}
                globalStepNumber={globalStepNumber}
                sectionIndex={sectionIndex}
                sectionId={section.tree_node_id}
                preloadedData={preloadedData}
                checkboxState={checkboxState}
                moveNodeType={moveNodeType}
                checkboxLabelColor={checkboxLabelColor}
                customOnNavigate={customOnNavigate}
                shouldDisableStepCheckbox={shouldDisableStepCheckbox}
                shouldShowStepCheckbox={shouldShowStepCheckbox}
                shouldDisableSubstepCheckbox={shouldDisableSubstepCheckbox}
                shouldShowSubstepCheckbox={shouldShowSubstepCheckbox}
                shouldDisableChildCheckbox={shouldDisableChildCheckbox}
                shouldShowChildCheckbox={shouldShowChildCheckbox}
              />
            );
          })}
        </>
      )}
    </div>
  );
};

export default MoveSectionNode;